import React, { useEffect } from "react";
import styles from "./searchchip.module.css";
import { Box } from "@chakra-ui/react";
import { useDispatch } from "react-redux";
import { filterActions, postActions, recruiterActions } from "redux/actions";
import { useLocation } from "react-router-dom";
import * as api from "services/api";

export const SearchChip = ({ name, clearSearch, searchTag }) => {
  const dispatch = useDispatch();
  const location = useLocation();
  useEffect(() => {
    if (!location.pathname.includes("findjob")) {
      clearSearch((state) => ({
        ...state,
        text: "",
        category: "",
        level: "",
        location: "",
        salary: "",
      }));
    }
  }, [location]);
  if (!name) return null;

  const removeButton = () => {
    dispatch(filterActions.setText(""));
    if (searchTag?.text?.includes(name)) {
      clearSearch((state) => ({ ...state, text: "" }));
      if (location.pathname.includes("findjob")) {
        dispatch(
          postActions.getPostsByFilters({
            ...(searchTag?.text && { jobRoleTitle: "" }),
            ...(searchTag?.category && { sector: searchTag?.categor }),
            ...(searchTag?.level !== "" && { requiredLevel: searchTag?.level }),
            ...(searchTag?.location && { location: searchTag?.location }),
            ...(searchTag?.salary && { packageOffered: searchTag?.salary }),
          })
        );
      } else {
        dispatch(filterActions.setText(""));
        api
          .findTalent(
            `?search=${""}&badges=${searchTag?.projectTypeState || ""}&tools=${
              searchTag?.tools || ""
            }&location=${""}&salary=${searchTag?.salary || ""}`
          )
          .then((res) => {
            dispatch(recruiterActions.setTalents(res.data.data));
          })
          .catch((err) => {
            console.log(err);
          });
      }
    }
    if (searchTag?.category?.includes(name)) {
      clearSearch((state) => ({ ...state, category: "" }));
      if (location.pathname.includes("findjob")) {
        dispatch(
          postActions.getPostsByFilters({
            ...(searchTag?.text && { jobRoleTitle: searchTag?.text }),
            ...(searchTag?.category && { sector: "" }),
            ...(searchTag?.level !== "" && { requiredLevel: searchTag?.level }),
            ...(searchTag?.location && { location: searchTag?.location }),
            ...(searchTag?.salary && { packageOffered: searchTag?.salary }),
          })
        );
      }
    }
    if (searchTag?.level?.includes(name)) {
      clearSearch((state) => ({ ...state, level: "" }));
      if (location.pathname.includes("findjob")) {
        dispatch(
          postActions.getPostsByFilters({
            ...(searchTag?.text && { jobRoleTitle: searchTag?.text }),
            ...(searchTag?.category && { sector: searchTag?.categor }),
            ...(searchTag?.level !== "" && { requiredLevel: "" }),
            ...(searchTag?.location && { location: searchTag?.location }),
            ...(searchTag?.salary && { packageOffered: searchTag?.salary }),
          })
        );
      }
    }
    if (searchTag?.location?.includes(name)) {
      clearSearch((state) => ({ ...state, location: "", text: "" }));
      if (location.pathname.includes("findjob")) {
        dispatch(
          postActions.getPostsByFilters({
            ...(searchTag?.text && { jobRoleTitle: searchTag?.text }),
            ...(searchTag?.category && { sector: searchTag?.categor }),
            ...(searchTag?.level !== "" && { requiredLevel: searchTag?.level }),
            ...(searchTag?.location && { location: "" }),
            ...(searchTag?.salary && { packageOffered: searchTag?.salary }),
          })
        );
      } else {
        dispatch(filterActions.setLocation(""));
        api
          .findTalent(
            `?search=${searchTag?.text || ""}&badges=${
              searchTag?.projectTypeState || ""
            }&tools=${searchTag?.tools || ""}&location=${""}&salary=${
              searchTag?.salary || ""
            }`
          )
          .then((res) => {
            dispatch(recruiterActions.setTalents(res.data.data));
          })
          .catch((err) => {
            console.log(err);
          });
      }
    }
    if (searchTag?.salary?.includes(name)) {
      clearSearch((state) => ({ ...state, salary: "" }));
      if (location.pathname.includes("findjob")) {
        dispatch(
          postActions.getPostsByFilters({
            ...(searchTag?.text && { jobRoleTitle: searchTag?.text }),
            ...(searchTag?.category && { sector: searchTag?.categor }),
            ...(searchTag?.level !== "" && { requiredLevel: searchTag?.level }),
            ...(searchTag?.location && { location: searchTag?.location }),
            ...(searchTag?.salary && { packageOffered: "" }),
          })
        );
      }
    }
    if (searchTag?.tools?.includes(name)) {
      dispatch(filterActions.setTools(""));
      clearSearch((state) => ({ ...state, tools: "" }));
      api
        .findTalent(
          `?search=${searchTag?.text || ""}&badges=${
            searchTag?.projectTypeState || ""
          }&tools=${""}&location=${searchTag?.location}&salary=${
            searchTag?.salary || ""
          }`
        )
        .then((res) => {
          dispatch(recruiterActions.setTalents(res.data.data));
        })
        .catch((err) => {
          console.log(err);
        });
    }
  };
  return (
    <Box className={styles.chipContainer}>
      <h6>{name}</h6>
      <h5 onClick={() => removeButton(name)}>X</h5>
    </Box>
  );
};
